import { Tooltip } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const RemoveControl = ({ onClick }) => {
    return (
        <Tooltip text={__('Remove', 'faqmate-blocks')}>
            <button onClick={onClick} className="faqmate-remove-btn">
                <span className="dashicons dashicons-remove"></span>
            </button>
        </Tooltip>
    );
};

export default RemoveControl;
